import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Input from "@material-ui/core/Input";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import Toolbar from "@material-ui/core/Toolbar";
import { getDriverDetail } from "../../../store/actions/admin/Admin";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";
import ArrowDownwardOutlinedIcon from "@material-ui/icons/ArrowDownwardOutlined";
import ArrowUpwardOutlined from "@material-ui/icons/ArrowUpwardOutlined";
import { connect } from "react-redux";
import {
  getAllOrders,
  getAllOrdersForDownload,
  getUserDetails,
  addToWallet,
  getAllTransactions,
} from "../../../store/actions/user/User";
import BackDrop from "../../../components/User/Preloader/BackDrop";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {
  GoogleMap,
  Marker,
  DirectionsService,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { Grid } from "@material-ui/core";
import StripeCheckout from "../Cart/StripeCheckout";
import TextField from "@material-ui/core/TextField";

import DateRangePicker from "react-bootstrap-daterangepicker";
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
import "bootstrap/dist/css/bootstrap.css";
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";

import KiwiFlightOrder from "./components/FlighOrder/KiwiFlightOrderCard";
import GoFlySmartFlightOrder from "./components/FlighOrder/GoFlySmartFlightOrderCard";
import HotelOrder from "./components/HotelOrder";
import ORDER_STATUS from "../../../constants/OrderStatus";

const drawerWidth = 240;

// const ORDER_STATUS = {
//     ORDER_SENT: 'Order Placed',
//     ORDER_RECEIVED: 'Order Received',
//     ORDER_ACCEPTED: 'Order Accepted',
//     ORDER_REJECTED: 'Order Rejected',
//     ORDER_OUT_FOR_DELIVERY: 'Out for Delivery',
//     ORDER_DELIVERED: 'Delivered'
// };

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    overflow: "hidden",
    maxHeight: "calc(100vh)",
    [theme.breakpoints.up("sm")]: {
      padding: "10%",
      paddingTop: "15%",
    },
  },
  drawer: {
    background: "white",
    paddingLeft: "2%",
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    background: "white",
    zIndex: 999,
    paddingLeft: "3%",
    paddingTop: "2%",
    boxShadow: "none",
    textAlign: "left",
    height: "15vh",
    [theme.breakpoints.up("md")]: {
      width: `calc(80%)`,
      margin: "10%",
      marginLeft: drawerWidth,
    },
    [theme.breakpoints.down("md")]: {
      height: "9vh",
      marginTop: "8%",
    },
    [theme.breakpoints.down("sm")]: {
      height: "9vh",
      marginTop: "7%",
      width: "90%",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "19%",
      height: "15vh",
      width: `calc(100%)`,
      zIndex: 999,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    marginTop: "18%",
    background: "white",
    borderRight: "none",
    margin: "10%",
    [theme.breakpoints.up("xs")]: {
      paddingLeft: "1%",
    },
    [theme.breakpoints.down("xs")]: {
      zIndex: "9999999999",
      margin: "0% !important",
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  mainPaper: {
    height: "66vh",
    overflow: "scroll",
    background: "white",
    width: "100%",
    marginTop: "4vh !important",
    [theme.breakpoints.up("sm")]: {
      marginTop: "4vh !important",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "3vh !important",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "24vh !important",
      height: "70vh !important",
    },
  },
  phone: {
    color: "grey",
    fontSize: "18px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "15%",
    },
  },
}));

const containerStyle = {
  width: "400px",
  height: "400px",
};

const COUNT = 10000;

function MyOrder(props) {
  const {
    window,
    getAllOrders,
    api_progress,
    orders,
    getUserDetails,
    userDetails,
    addToWallet,
    transactions,
    getAllTransactions,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [activeMenu, setActiveMenu] = React.useState(0);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [orderList, updateOrderList] = useState([]);
  const [orderCount, updateOrderCount] = useState(1);
  const [pageNo, updatePageNo] = useState(1);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [driverLocationOpen, setDriverLocationOpen] = React.useState(false);
  const [driverOpen, setDriverOpen] = React.useState(false);
  const [variant, setVariant] = React.useState([]);
  const [directionResponse, setDirectionResponse] = React.useState(null);
  const [currentOrder, setCurrentOrder] = React.useState(null);
  const [driverApiCall, setDriverApiCall] = React.useState(null);
  const [value, setValue] = React.useState(null);
  const [showPayment, setShowPayment] = React.useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleClickOpen = (variant) => {
    setVariant(variant);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDriverClose = () => {
    setDriverLocationOpen(false);
    setDriverOpen(false);
    clearInterval(driverApiCall);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    getAllOrders(pageNo, COUNT)
      .then((resp) => {
        setLoading(false);
        updateOrderList(resp?.data || []);
        updateOrderCount(resp?.total_data || 1);
      })
      .catch((err) => console.log("ORDER DATA ERR", err));
    getUserDetails();
  }, []);

  useEffect(() => {
    if (activeMenu === 1) {
      getAllTransactions(pageNo, COUNT);
    }
  }, [activeMenu]);

  useEffect(() => {
    if (props.driver && driverLocationOpen) setDriverOpen(true);
  }, [props.driver]);

  const renderDot = (fillDot) => {
    return (
      <div
        style={{
          boxSizing: "border-box",
          display: "inline-block",
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          border: "3px solid rgba(183, 186, 195, 0.2)",
        }}
      >
        {fillDot ? (
          <div
            style={{
              boxSizing: "border-box",
              display: "flex",
              "-webkit-box-align": "center",
              alignItems: "center",
              "-webkit-box-pack": "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "rgb(1, 160, 90)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 9 7"
              height="9px"
              width="14px"
              fill="white"
              class="sc-64ptou-0 ifUlNW"
            >
              <polygon
                points="6.615 11.549 12.25 5.914 11.59 5.254 6.615 10.228 4.656 8.269 3.996 8.93"
                transform="translate(-4 -5)"
              ></polygon>
            </svg>
          </div>
        ) : (
          <div
            style={{
              boxSizing: "border-box",
              display: "flex",
              "-webkit-box-align": "center",
              alignItems: "center",
              "-webkit-box-pack": "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              border: "4px solid rgb(183, 186, 195)",
            }}
          ></div>
        )}
      </div>
    );
  };

  const handleLocationOpen = (driverId, order) => {
    if (order.driver && order.status === ORDER_STATUS.ORDER_OUT_FOR_DELIVERY) {
      props.getDriverDetail(driverId);
      const cb = setInterval(() => {
        props.getDriverDetail(driverId);
      }, 3000);
      setDriverApiCall(cb);
    } else {
      setDriverOpen(true);
    }
    setDriverLocationOpen(true);
    setCurrentOrder(order);
  };

  const onLoad = (marker) => {
  };

  const renderOrder = (order) => {
    var isPickAndDrop = false;
    if (order && order.orderType == "PicknDrop") {
      isPickAndDrop = true;
    } else if (order && order.orderType == "HotelBooking") {
      return <HotelOrder order={order} {...props} />;
    } else if (order && order.orderType == "FlightBooking")
      return order.isB2b ? (
        <GoFlySmartFlightOrder order={order} {...props} />
      ) : (
        <KiwiFlightOrder order={order} {...props} />
      );

    var orderStatusColor = "black";
    if (order.status === ORDER_STATUS.ORDER_REJECTED) {
      orderStatusColor = "red";
    } else if (
      order.status === ORDER_STATUS.ORDER_ACCEPTED ||
      order.status === ORDER_STATUS.ORDER_DELIVERED
    ) {
      orderStatusColor = "green";
    }
    return (
      <div style={{ paddingTop: "7%", paddingLeft: "7%", paddingRight: "7%" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <GridContainer>
              <GridItem xs={4} sm={4} md={4}>
                <img
                  style={{ borderRadius: "5px" }}
                  src={
                    isPickAndDrop
                      ? order.attachment
                      : order?.vendorDetails?.vendorDetails
                      ? order?.vendorDetails?.vendorDetails[0]?.logo
                      : ""
                  }
                  alt=""
                  title=""
                  height="53px"
                  class="sc-1go0t46-0 iGlQOH"
                />
              </GridItem>
              <GridItem xs={8} sm={8} md={8}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    {isPickAndDrop
                      ? "Pick And Drop"
                      : order.vendorDetails?.vendorDetails?.[0]?.name}
                  </div>
                  <p>{new Date(order.createdAt).toLocaleString()}</p>
                  <p>
                    <b>Order Ref No -</b> {order.orderRef}
                  </p>
                  {order.status !== ORDER_STATUS.ORDER_DELIVERED && (
                    <span
                      style={{
                        background: "rgb(1, 160, 90)",
                        border: "1px solid rgb(1, 160, 90)",
                        color: "rgb(255, 255, 255)",
                        fontWeight: "bold",
                        cursor: "pointer",
                        borderRadius: "16px",
                        padding: "4px",
                        fontSize: "12px",
                      }}
                      onClick={() => handleLocationOpen(order.driver, order)}
                    >
                      Track Order
                    </span>
                  )}
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={6}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <div>
              <b>
                Paid:{" "}
                <span style={{ color: "rgb(1, 160, 90)" }}>
                  AUD {order.totalPrice}
                </span>
              </b>
            </div>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: "2%",
            }}
          >
            <p>
              <ArrowUpwardOutlined
                style={{
                  border: "1px solid",
                  borderRadius: "28px",
                  background: "rgb(1, 160, 90)",
                  color: "white",
                }}
              ></ArrowUpwardOutlined>
              &nbsp;&nbsp;&nbsp;
              <span>
                {isPickAndDrop
                  ? order?.pickUpAddress?.street
                  : order.vendorDetails?.order?.vendorDetails?.[0]?.address
                      ?.building_number}
              </span>
            </p>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: "2%",
            }}
          >
            <p>
              <ArrowDownwardOutlinedIcon
                style={{
                  border: "1px solid",
                  borderRadius: "28px",
                  background: "rgb(1, 160, 90)",
                  color: "white",
                }}
              ></ArrowDownwardOutlinedIcon>
              &nbsp;&nbsp;&nbsp;
              <span>
                {isPickAndDrop
                  ? order?.dropAddress?.street
                  : order.address?.street}
              </span>
            </p>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: "2%",
            }}
          >
            {!isPickAndDrop && (
              <p>
                {order?.orderDetails &&
                  order?.orderDetails.map((item) => {
                    return (
                      <>
                        {`${
                          (item?.products &&
                            item?.products.length > 0 &&
                            item?.products[0]?.name) ||
                          ""
                        } × ${item?.quantity} `}
                        {item.variant && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClickOpen(item.variant)}
                          >
                            (Customized)
                          </span>
                        )}
                        {" , "}
                      </>
                    );
                  })}
              </p>
            )}
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{ marginTop: "2%" }}>
            <Divider></Divider>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: "2%",
            }}
          >
            <p style={{ color: orderStatusColor }}>
              <b>{order.status}</b>
            </p>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  const renderTransaction = (t) => {
    return (
      <div>
        <GridContainer style={{ color: "black" }}>
          <GridItem xs={12} sm={12} md={6}>
            <GridContainer>
              <GridItem xs={8} sm={8} md={8}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <Typography component="p" style={{ color: "black" }}>
                    {t.addedToWallet ? "Added to Wallet" : "Paid from Wallet"}
                  </Typography>
                  <Typography component="p" style={{ color: "black" }}>
                    {new Date(t.createdAt).toLocaleString()}
                  </Typography>
                  <Typography component="p" style={{ color: "black" }}>
                    <b>Order Ref No -</b> {t.orderRef}
                  </Typography>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={6}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Typography
              component="span"
              style={{
                color: t.addedToWallet ? "rgb(1, 160, 90)" : "red",
                fontWeight: "bold",
              }}
            >
              {t.data && t.data.currency} {t.amount}
            </Typography>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginTop: "2%",
            }}
          >
            <Typography
              component="p"
              style={{ color: "green", fontWeight: "bold" }}
            >
              {t.status}
            </Typography>
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            style={{ marginTop: "2%", marginBottom: "2%" }}
          >
            <Divider></Divider>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  const drawer = (
    <div
      style={{
        background: "rgb(243, 243, 245)",
        paddingLeft: "5%",
        paddingTop: "2%",
        height: "100vh",
      }}
    >
      <List>
        {["Orders List", "TravelPick Cash"].map((text, index) => (
          <ListItem
            onClick={() => setActiveMenu(index)}
            button
            key={text}
            style={index === activeMenu ? { background: "white" } : {}}
          >
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  const JSONToCSVConvertor = (ReportTitle, ShowLabel) => {
    props
      .getAllOrdersForDownload(
        pageNo,
        COUNT,
        startDate?.valueOf(),
        endDate?.valueOf()
      )
      .then((data) => {
        if (data) {
          const JSONData = data.data;
          //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
          var arrData =
            typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;

          var CSV = "";

          //This condition will generate the Label/Header
          if (ShowLabel) {
            var row =
              "Order Ref No,Price,Placed On,No Of Packages,PickUp Phone Number,Pickup Building Number,PickUp Address,Drop Phone Number,Drop Building Number,Drop Address,Status" +
              ",";
            row.slice(0, row.length - 1);
            //append Label row with line break
            CSV += row + "\r\n";
          }

          //1st loop is to extract each row
          for (var i = 0; i < arrData.length; i++) {
            var row = "";

            row += '"' + arrData[i]["orderRef"] + '",';
            row += '"' + arrData[i]["totalPrice"] + '",';
            row +=
              '"' + new Date(arrData[i]["createdAt"])?.toLocaleString() + '",';
            row +=
              '"' +
              (arrData[i]["noOfPackages"] ? arrData[i]["noOfPackages"] : "") +
              '",';
            row +=
              '"' +
              (arrData[i].pickUpAddress?.["phone_number"]
                ? arrData[i].pickUpAddress?.["phone_number"]
                : "") +
              '",';
            row +=
              '"' +
              (arrData[i].pickUpAddress?.["building_number"]
                ? arrData[i].pickUpAddress?.["building_number"]
                : "") +
              '",';
            row +=
              '"' +
              (arrData[i].pickUpAddress?.["street"]
                ? arrData[i].pickUpAddress?.["street"]
                : "") +
              '",';
            row +=
              '"' +
              (arrData[i].dropAddress?.["phone_number"]
                ? arrData[i].dropAddress?.["phone_number"]
                : "") +
              '",';
            row +=
              '"' +
              (arrData[i].dropAddress?.["building_number"]
                ? arrData[i].dropAddress?.["building_number"]
                : "") +
              '",';
            row +=
              '"' +
              (arrData[i].dropAddress?.["street"]
                ? arrData[i].dropAddress?.["street"]
                : "") +
              '",';
            row += '"' + arrData[i]["status"] + '",';

            row.slice(0, row.length - 1);

            //add a line break after each row
            CSV += row + "\r\n";
          }

          if (CSV === "") {
            alert("Invalid data");
            return;
          }

          //Generate a file name
          var fileName = "Report_";
          //this will remove the blank-spaces from the title and replace it with an underscore
          fileName += ReportTitle.replace(/ /g, "_");

          //Initialize file format you want csv or xls
          var uri = "data:text/csv;charset=utf-8," + escape(CSV);

          // Now the little tricky part.
          // you can use either>> window.open(uri);
          // but this will not work in some browsers
          // or you will not get the correct file extension

          //this trick will generate a temp <a /> tag
          var link = document.createElement("a");
          link.href = uri;

          //set the visibility hidden so it will not effect on your web-layout
          link.style = "visibility:hidden";
          link.download = fileName + ".csv";

          //this part will append the anchor tag and remove it after automatic click
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };

  const directionsCallback = (response) => {
    if (response !== null) {
      if (response.status === "OK") {
        setDirectionResponse(response);
        // this.setState(
        //   () => ({
        //     response
        //   })
        // )
      } else {
        console.log("response: ", response);
      }
    }
  };

  const handleChange = (prop) => (event) => {
    setValue(event.target.value);
  };

  const proceedToPayment = (token) => {
    // const tempPayload = { ...checkoutAddress };
    // tempPayload.payment_token = token?.id;
    // placeNewOrder(tempPayload).then(async (data) => {
    //     await emptyCart();
    //     await getCartItems()
    //     handleSideBar();
    // }).catch(err => {
    //     handleSideBar();
    // })
    const amount = value;
    addToWallet({ payment_token: token?.id, amount: amount }).then(
      async (data) => {
        setValue(null);
        setShowPayment(false);
        getUserDetails();
      }
    );
  };

  const handleEvent = (event, picker) => {
  };
  const handleCallback = (start, end, label) => {
    setStartDate(start.tz("Australia/Sydney").startOf("day"));
    setEndDate(end.tz("Australia/Sydney").startOf("day"));
    setLoading(true);
    getAllOrders(
      pageNo,
      COUNT,
      start?.tz("Australia/Sydney").startOf("day").valueOf(),
      end?.tz("Australia/Sydney").startOf("day").valueOf()
    ).then((resp) => {
      setLoading(false);
      updateOrderList(resp?.data || []);
      updateOrderCount(resp?.total_data || 1);
    });
    // props.getOrderList(orderStatus, undefined, searchText, orderType, start?.valueOf(), end?.valueOf());
    // updatePageNo(1)
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      {/* <BackDrop open={api_progress}></BackDrop> */}
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position="fixed" className={classes.appBar}>
          <div>
            <Typography
              variant="h6"
              style={{ marginBottom: "1%", marginTop: "1%" }}
            >
              <IconButton
                color="black"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
              Hi{" "}
              {userDetails.firstName
                ? userDetails.firstName + " " + userDetails.lastName
                : "TravelPicker"}
              !
            </Typography>
            <span className={classes.phone}>
              <PhoneIcon fontSize="small"></PhoneIcon>{" "}
              {userDetails.phone_number}&nbsp;
            </span>
          </div>
        </AppBar>
        <nav className={classes.drawer} aria-label="mailbox folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <div className={classes.mainPaper}>
          {loading && (
            <GridContainer
              style={{ paddingTop: "4%", textAlign: "left", paddingLeft: "1%" }}
            >
              <GridItem xs="6">
                <Typography variant="h6">Loading Data...</Typography>
              </GridItem>
            </GridContainer>
          )}
          {activeMenu === 0 && !loading && (
            <>
              {" "}
              <GridContainer
                style={{
                  paddingLeft: "2%",
                  paddingTop: "4%",
                  paddingRight: "2%",
                }}
              >
                <GridItem xs="8">
                  <DateRangePicker
                    onEvent={handleEvent}
                    onCallback={handleCallback}
                  >
                    <TextField
                      fullWidth
                      type="text"
                      placeholder="Daterange"
                      value={
                        startDate
                          ? (startDate ? startDate.format("DD/MM/YYYY") : "") +
                            "-" +
                            (endDate ? endDate.format("DD/MM/YYYY") : "")
                          : ""
                      }
                    />
                  </DateRangePicker>
                </GridItem>
                <GridItem xs="12" md="4">
                  <Button
                    style={{
                      backgroundColor: "var(--themegreen)",
                      color: "white",
                    }}
                    fullWidth
                    onClick={() => JSONToCSVConvertor("OrderReport", true)}
                  >
                    Download Report
                  </Button>
                </GridItem>
              </GridContainer>
              <hr />
            </>
          )}

          {activeMenu === 0 && orders && orders.length > 0 && !loading && (
            <>
              {orders.map((order) => {
                return (
                  <>
                    {renderOrder(order)}
                    <Divider></Divider>
                  </>
                );
              })}
            </>
          )}
          {activeMenu === 1 && (
            <div style={{ margin: "5%", width: "90%" }}>
              <Grid container>
                <Grid item xs={4} style={{ textAlign: "left" }}>
                  <span>
                    <b>Total Wallet Balance</b>
                  </span>
                </Grid>
                <Grid item xs={5}></Grid>
                <Grid item xs={1}>
                  <Divider orientation="vertical"></Divider>
                </Grid>
                <Grid item xs={2}>
                  <span>
                    <b>
                      AUD{" "}
                      {userDetails.walletAmount ? userDetails.walletAmount : 0}
                    </b>
                  </span>
                </Grid>
                <Grid item xs={12}>
                  <hr style={{ marginTop: "3%", marginBottom: "6%" }}></hr>
                </Grid>
                {showPayment ? (
                  <Grid item xs={12}>
                    <StripeCheckout handlePayment={proceedToPayment} />
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={8}>
                      <FormControl fullWidth>
                        <InputLabel htmlFor="standard-adornment-amount">
                          Amount
                        </InputLabel>
                        <Input
                          id="standard-adornment-amount"
                          value={value}
                          onChange={handleChange("value")}
                          startAdornment={
                            <InputAdornment position="start">
                              AUD
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={3}>
                      <Button
                        fullWidth
                        style={{
                          background:
                            !value || value <= 0 ? "grey" : "rgb(1, 160, 90)",
                          border:
                            !value || value <= 0
                              ? "1px solid grey"
                              : "1px solid rgb(1, 160, 90)",
                          color: "rgb(255, 255, 255)",
                          fontWeight: "bold",
                        }}
                        onClick={() => setShowPayment(true)}
                        disabled={!value || value <= 0}
                      >
                        Add Money
                      </Button>
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  <hr style={{ marginTop: "3%", marginBottom: "6%" }}></hr>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "left" }}>
                  <span>
                    <b>Previous Transactions</b>
                  </span>
                </Grid>
                <Grid item xs={12}>
                  <hr></hr>
                </Grid>
                {transactions?.map((t) => {
                  return (
                    <Grid item xs={12} style={{ textAlign: "left" }}>
                      {renderTransaction(t)}
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          )}
        </div>
      </div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <MuiDialogTitle>
          <Typography gutterBottom>
            <b>Add Ons</b>
          </Typography>
        </MuiDialogTitle>
        <MuiDialogContent>
          {variant &&
            variant.map((v) => {
              return (
                <>
                  <Typography gutterBottom>
                    <span>
                      <b>{v.name}</b>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <span style={{ float: "right" }}>{v.price + " AUD"}</span>
                  </Typography>
                </>
              );
            })}
        </MuiDialogContent>
        <MuiDialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Close
          </Button>
        </MuiDialogActions>
      </Dialog>
      <Dialog
        onClose={handleDriverClose}
        aria-labelledby="customized-dialog-title"
        open={driverOpen}
      >
        <MuiDialogTitle>
          <Typography gutterBottom>
            <b>Driver Location</b>
          </Typography>
        </MuiDialogTitle>
        <MuiDialogContent>
          {/* <div className="map col-12 col-lg-12" style={{ height: '20em' }}>
                        <iframe
                            title="contact"
                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBNC9xN76yYhSl9KyDN0mNoKLa63Fkog1M&q=${props.driver?.latitude},${props.driver?.longitude}&center=${props.driver?.latitude},${props.driver?.longitude}&zoom=18`}
                            style={{ border: 0 }}
                            allowFullScreen
                        />
                    </div> */}
          {currentOrder?.driver &&
          currentOrder?.status === ORDER_STATUS.ORDER_OUT_FOR_DELIVERY &&
          props.driver?.latitude ? (
            <GoogleMap mapContainerStyle={containerStyle} zoom={18}>
              {/* Child components, such as markers, info windows, etc. */}
              <Marker
                onLoad={onLoad}
                position={{
                  lat: props.driver?.latitude,
                  lng: props.driver?.longitude,
                }}
                icon={{
                  url:
                    "https://grospicklive.s3.ap-southeast-2.amazonaws.com/Media/1622905656415-GROSPICK155744.png",
                  scaledSize: { height: 22, width: 28 },
                }}
              />
              <Marker
                onLoad={onLoad}
                position={{
                  lat: parseFloat(
                    currentOrder?.address
                      ? currentOrder?.address?.latitude
                      : currentOrder?.dropAddress?.latitude
                  ),
                  lng: parseFloat(
                    currentOrder?.address
                      ? currentOrder?.address?.longitude
                      : currentOrder?.dropAddress?.longitude
                  ),
                }}
              />
              <DirectionsService
                // required
                options={{
                  destination: {
                    lat: parseFloat(
                      currentOrder?.address
                        ? currentOrder?.address?.latitude
                        : currentOrder?.dropAddress?.latitude
                    ),
                    lng: parseFloat(
                      currentOrder?.address
                        ? currentOrder?.address?.longitude
                        : currentOrder?.dropAddress?.longitude
                    ),
                  },
                  origin: {
                    lat: props.driver?.latitude,
                    lng: props.driver?.longitude,
                  },
                  travelMode: "DRIVING",
                }}
                // required
                callback={directionsCallback}
              />
              {directionResponse !== null && (
                <DirectionsRenderer
                  // required
                  options={{
                    directions: directionResponse,
                    suppressMarkers: true,
                  }}
                  // optional
                  onLoad={(directionsRenderer) => {
                    // console.log('DirectionsRenderer onLoad directionsRenderer: ', directionsRenderer)
                  }}
                  // optional
                  onUnmount={(directionsRenderer) => {
                    // console.log('DirectionsRenderer onUnmount directionsRenderer: ', directionsRenderer)
                  }}
                />
              )}
            </GoogleMap>
          ) : (
            <span>{"Start Tracking once order is picked up"}</span>
          )}
        </MuiDialogContent>
        <MuiDialogActions>
          <Button autoFocus onClick={handleDriverClose} color="primary">
            Close
          </Button>
        </MuiDialogActions>
      </Dialog>
    </>
  );
}

MyOrder.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const mapDispatchWithProps = (dispatch) => {
  return {
    getAllOrders: (pageNumber, count, startTime, endTime) =>
      dispatch(getAllOrders(pageNumber, count, startTime, endTime)),
    getAllOrdersForDownload: (pageNumber, count, startTime, endTime) =>
      dispatch(getAllOrdersForDownload(pageNumber, count, startTime, endTime)),
    getAllTransactions: (pageNumber, count) =>
      dispatch(getAllTransactions(pageNumber, count)),
    getUserDetails: () => dispatch(getUserDetails()),
    addToWallet: (payload) => dispatch(addToWallet(payload)),
    getDriverDetail: (driverId) => dispatch(getDriverDetail(driverId)),
  };
};

const mapStateWithProps = (state) => ({
  api_progress: state.user.api_progress,
  orders: state.user.orders?.data,
  userDetails: state.user.userDetails,
  driver: state.admin.driver,
  transactions: state.user.transactions?.data,
});

export default connect(mapStateWithProps, mapDispatchWithProps)(MyOrder);
